import { useContext } from 'react'

import { portalTypes } from '@/constants'
import AppContext from '@/context/AppContext'

const useCancellationsPortal = () => {
  const { context } = useContext(AppContext)

  return {
    portalType: context?.merchantInfo?.preferences?.portal_type,
    isCancellationsPortal:
      context?.merchantInfo?.preferences?.portal_type === portalTypes.cancellations ||
      context?.merchantInfo?.preferences?.portal_type === portalTypes.returnToSender,
  }
}

export default useCancellationsPortal
